<template>
  <section id="pawpulse" class="meet-pawpulse">
    <div class="background-container">
      <!-- Background image container -->
    </div>
  <div class="content-container">
    <div class="content">
        <div class="text-content">
          <div class="lightbox title-box">
            <div class="main-title">
              <h1 class="meet">{{ translate('landing.meet', 'MEET') }}</h1>
              <h1 class="pawpulse">{{ translate('landing.pawpulse_name', 'PAWPULSE') }}</h1>
            </div>
            <div class="subtitle-box">
              <h2 class="subtitle">{{ translate('landing.subtitle', 'Your Customer Feedback & Complaint Management Solution') }}</h2>
            </div>
          </div>
        </div>

        <div class="demo-button-section">
          <a class="cta-button button" @click="goToHome">{{ translate('landing.get_demo', 'GET A DEMO') }}</a>
        </div>

        <div class="social-section">
          <div class="social-container">
            <p class="follow-text">{{ translate('landing.follow_us', 'FOLLOW US') }}</p>
            <div class="social-icons">
              <a href="https://www.linkedin.com/company/technopaws" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" class="social-icon linkedin">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
              <a href="https://www.youtube.com/@technopawsco" target="_blank" rel="noopener noreferrer" aria-label="YouTube" class="social-icon youtube">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
              </a>
              <a href="https://www.instagram.com/technopaws_us" target="_blank" rel="noopener noreferrer" aria-label="Instagram" class="social-icon instagram">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/></svg>
              </a>
              <a href="https://www.tiktok.com/@technopaws_us" target="_blank" rel="noopener noreferrer" aria-label="TikTok" class="social-icon tiktok">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/></svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useStore } from 'vuex'

export default {
  name: 'MeetPawPulse',
  setup() {
    const store = useStore()
    
    const translate = (key, fallback) => {
      const translations = store.state.translations
      const parts = key.split('.')
      
      let value = translations
      for (const part of parts) {
        if (value && value[part]) {
          value = value[part]
        } else {
          return fallback
        }
      }
      
      return typeof value === 'string' ? value : fallback
    }
    
    return {
      translate
    }
  },
  methods: {
    goToHome() {
      this.$router.push('/home');
    }
  }
}
</script>

<style scoped>
/* Usamos las variables globales de fuentes definidas en App.vue */
:root, body, * {
  font-family: var(--font-primary);
}

:root {
  /* Variables globales si son necesarias */
}

.meet-pawpulse {
  position: relative;
  min-height: 100vh;
  width: 100%;
  display: grid;
  grid-template-rows: 1fr;
  color: white;
  overflow: hidden;
}

/* Nuevo contenedor para el fondo */
.background-container {
  position: absolute;
  top: 5rem;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/technopawsImages/initialDashboard.png');
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  background-color: #09405c; /* Color de fondo que extiende la imagen */
  z-index: 1;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
}

.text-content {
  max-width: 600px;
  margin: 5rem 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: flex-end;
  width: auto;
}

.lightbox {
  background: rgba(9, 64, 92, 0.9);
  backdrop-filter: blur(8px);
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-left: 8rem;
}

.subtitle-box {
  max-width: 600px;
}

.title-box {
  align-self: flex-start;
}

.subtitle {
  /* Usando la clase global h2 para tamaño y peso */
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.main-title {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  text-align: left;
}

.meet {
  /* Usando la clase global h1 para tamaño y peso */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 2px;
}


.demo-button-section {
  position: relative;
  z-index: 2;
}

.cta-button {
  background-color: #09405c ;
}

.follow-text {
  margin: 1.5rem;
}

.contact-email {
  font-size: 1.1rem;
}

.social-follow {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* Los estilos de los iconos sociales ahora vienen de las clases globales en App.vue */

/* Media queries para móviles pequeños */
@media (max-width: 480px) {
  .background-container {
    background-image: url('@/assets/technopawsImages/movil-technopaws.png') !important;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #09405c;
    position: relative;
    height: 100vh;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 1;
  }

  .content-container { 
    height: 40vh;
    padding-top: 120px; /* Espacio en la parte superior para ver el header */
    align-items: flex-end;
  }
  
  .content {
    align-items: left;
    background-color: #09405c;
    backdrop-filter: blur(5px);
    border-radius: 15px;
  }
  .meet-pawpulse {
    min-height: 40vh;
    width: 100%;
    min-width: 100%;
    overflow-x: hidden;
    padding: 0rem 0 3rem 0;
    background-color: #09405c;
  }
  
  .text-content {
    margin: 0.5rem 0;
    gap: 1rem;
    width: 50%;
    max-width: 100%;
    align-items: center;
    border-radius: 15px;
    margin-right: 0;
    width: 100%;
    box-sizing: border-box;
    background: rgba(9, 64, 92, 0.8); /* Más transparente */
    backdrop-filter: blur(5px);
  }
  
  
  .lightbox {
    padding: 1rem;
    margin: 0rem;
    width: 100%;
    box-sizing: border-box;
    background:rgba(255, 255, 255, 0.05); /* Fondo clarito y translúcido */
    border-radius: 18px;
    backdrop-filter: blur(5px);
  }
  
  .main-title,
  .subtitle-box {
    color: white;
    text-shadow: none;
    text-align: center;
  }
  
  .title-box {
    align-self: center;
    width: 100%;
    text-align: center;
    align-self: flex-end;
  }
  
  .main-title {
    align-items: center;
    text-align: center;
  }
  
  .subtitle-box {
    width: 100%;
    text-align: center;
  }
  
  .subtitle {
    text-align: center;
    margin: 1rem 0;
  }
  
  .meet {
    text-align: center;
  }
  
  .pawpulse {
    text-align: center;
  }
  
  .demo-button-section {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 1rem 0 1rem;
  }

  .social-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-button {
  background-color:  #f3a261 ;
}
}
</style>
